import { ProductName } from '@ui/product/product-name.tsx';
import { ProductDescription } from '@ui/product/product-description.tsx';
import { ProductPrice } from '@ui/product/product-price.tsx';
import { ProductAction } from '@ui/product/product-action.tsx';
import { ProductBadge } from '@ui/product/product-badge.tsx';
import { ProductFavorite } from '@ui/product/product-favorite.tsx';
import { ProductCardSection } from '@ui/product/product-card-section.tsx';
import { LazyImage } from '@ui/common/lazy-image.tsx';

export interface ProductCardProps {
  image?: string;
  title?: string;
  description?: string;
  price?: string;
  discount?: string;
  badge?: string;
  isLoading?: boolean;
  isShowPrice?: boolean;
  isShowDiscount?: boolean;
  isFavoriteShow?: boolean;
  isFavoriteSelected?: boolean;
  isLeadingShow?: boolean;
  isSelected?: boolean;
  onPress?: () => void;
  onPressAction?: () => void;
  onPressFavorite?: () => void;
  size?: 'sm' | 'lg';
}

export const ProductCard = ({
  image = '/product_placeholder.jpg',
  badge,
  title = 'Название товара',
  description = 'Описание товара',
  price = '1000',
  discount = '1000',
  isShowPrice = false,
  isShowDiscount = false,
  isFavoriteShow = false,
  isFavoriteSelected = false,
  isLoading = false,
  isLeadingShow = false,
  isSelected = false,
  onPress,
  onPressAction,
  onPressFavorite,
  size,
}: ProductCardProps) => {
  return (
    <div className="relative max-w-80 select-none cursor-pointer">
      <ProductCardSection type="image" onPress={onPress}>
        <LazyImage src={image} />
      </ProductCardSection>

      <ProductCardSection type="badge">
        {badge && <ProductBadge text={badge} />}
        {isFavoriteShow && (
          <ProductFavorite
            onPress={onPressFavorite}
            isSelected={isFavoriteSelected}
          />
        )}
      </ProductCardSection>

      <ProductCardSection type="name" onPress={onPress}>
        <ProductName isLoading={isLoading} text={title} />
      </ProductCardSection>

      <ProductCardSection type="description" onPress={onPress}>
        <ProductDescription isLoading={isLoading} text={description} />
      </ProductCardSection>

      {(isShowPrice || isShowDiscount) && (
        <ProductCardSection
          type="price"
          onPress={onPress}
          leading={
            isLeadingShow && (
              <ProductAction isLoading={isLoading} onPress={onPress} isIcon />
            )
          }
        >
          {isShowPrice && <ProductPrice isLoading={isLoading} text={price} />}
          {isShowDiscount && !isLoading && (
            <ProductPrice isDiscount text={discount} />
          )}
        </ProductCardSection>
      )}

      <ProductCardSection type="action">
        <ProductAction
          size={size}
          isLoading={isLoading}
          isSelected={isSelected}
          onPress={onPressAction}
        />
      </ProductCardSection>
    </div>
  );
};
